import { useMutation } from 'react-query'

import { updateProduct } from '../query-api'

export const useUpdateProduct = () => {
  const { mutate: update, isLoading: isProcessing, ...rest } = useMutation(updateProduct)

  return {
    update,
    isProcessing,
    ...rest,
  }
}
